import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import ExtendedMdxRender from '../components/extendedMdxRender'
import SEO from '../components/seo'
import Container from '../components/container'
import Layout from '../components/layout'
import Top from '../components/handlers/top'
import theme from '../../config/theme'
import { css } from '@emotion/core'
import get from 'lodash/get'
import qrBase64Url from "../components/resume-qr"

import '../styles/resume.css'

import styled from '@emotion/styled'

const p = styled.div`
  text-align: left;
  line-height: 1.7;
  margin: 1.2rem 0 0.6rem;
`


export default function Studio({ data: { site, allMdx } }) {
  const handlePrint = () => window.print()
  const mdx = allMdx.edges[0].node
  const [isLight, setIsLight] = useState(false)

  useEffect(() => {
    document.querySelector('html').dataset.theme = isLight ? 'light' : 'dark'
  }, [isLight])

  useEffect(() => {
    return () => {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      document.querySelector('html').dataset.theme = prefersDark ? 'dark' : 'light'
    }
  }, [])

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(window.innerWidth < 640)
  }, [])

  return (
    <Layout
      headerColor={theme.colors.white}
      site={site}
      frontmatter={mdx.fields}
      headerLink="/"
      noFooter={mdx.fields.noFooter}
    >
      <SEO
        frontmatter={mdx.fields}
        metaImage={get(mdx, 'fields.banner.childImageSharp.fluid.src')}
      />
      <article
        css={css`
          width: 100%;
          display: flex;
        `}
      >
        <Container className="resume-wrap"
          style={{
            paddingTop: isMobile ? '100px' : '40px',
          }}>
          <div
            css={css`
            position: absolute;
            top: 20px;
            left: 20px;
            z-index: 100;
            display: flex;
            gap: 8px;
          `}
          >
            <button
              className="resume-theme-btn"
              onClick={() => setIsLight(s => !s)}
              css={css`
              padding: 8px 18px;
              background: ${isLight ? '#1a1a1a' : '#f5f5f5'};
              color: ${isLight ? '#fff' : '#1a1a1a'};
              border: 1px solid ${isLight ? '#333' : '#ddd'};
              border-radius: 6px;
              font-size: 14px;
              cursor: pointer;
              font-family: 'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif;
              transition: background 0.2s, color 0.2s, border-color 0.2s;
              &:hover {
                background: ${isLight ? '#333' : '#e8e8e8'};
              }
            `}
            >
              {isLight ? '🌙' : '☀️'}
            </button>
            <button
              className="resume-print-btn"
              onClick={handlePrint}
              css={css`
              padding: 8px 18px;
              background: #1a1a1a;
              color: #fff;
              border: none;
              border-radius: 6px;
              font-size: 14px;
              cursor: pointer;
              font-family: 'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif;
              transition: background 0.2s;
              &:hover {
                background: #333;
              }
            `}
            >
              打印简历
            </button>
          </div>
          {/* <Toc {...{ headings: mdx.headings, slug: mdx.fields.slug, toc: mdx.fields.toc }} /> */}
          <ExtendedMdxRender coms={{
            p: p,
          }}>{mdx.body}</ExtendedMdxRender>
          <img className="resume-qr" src={qrBase64Url} alt="qr" />
        </Container>
        <Top />
      </article>
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        keywords
      }
    }
    allMdx(
      filter: {fileAbsolutePath: {regex: "//root/resume/"}}
      sort: {order: DESC, fields: [frontmatter___date]}
    ) {
      edges {
        node {
          fields {
            title
            noFooter
            description
            slug
            description
            tags
          }
          body
        }
      }
    }
  }
`
